module.exports = __webpack_public_path__ + "img/3.cf97af01.png";